import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Loading } from "wup-module1-base";
import { LocalizationService } from "../../../../Services";
import "./style.css";

const LocalizationSelect = ({ value, setValue, setIsRemote = false }) => {
    const [loading, setLoading] = useState(true);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        (async () => {
            setOptions((await LocalizationService.get()).data);
            setLoading(false);
        })();
    }, []);

    if (loading) {
        return (
            <div>
                <Loading />
            </div>
        );
    }

    const handleChange = (event) => {
        const selected = options.find((option) => option.id === Number(event.target.value));

        setValue(event.target.value);
        setIsRemote(selected.is_remote);
    }

    return (
        <Form.Select className="localization-select" aria-label="Meeting localization select." onChange={handleChange}>
            <option>-- Wybierz --</option>
            {options.map((option) =>
                <option value={option.id}  selected={value === option.id}>
                    {option.localization}
                </option>
            )}
        </Form.Select>
    );
}

export default LocalizationSelect;
